module.exports = __webpack_public_path__ + "img/zm-logo.96063990.png";